<template>
  <b-modal
    id="error-modal"
    :visible="$err.isActive()"
    :title="'Error ' + $err.getTitle()"
    no-close-on-backdrop
    size="sm"
    ok-only
    title-tag="h4"
    @close="$err.hide()"
  >
    <p style="word-break: break-word;" class="error-wrapper">
      <font-awesome-icon class="text-danger" icon="flushed" />
      <span>{{ $err.getMessage() }}</span>
    </p>
    <div slot="modal-footer" class="container">
      <div class="row justify-content-end">
        <div class="col col-md-3 pl-0 pr-1">
          <b-button
            variant="primary"
            size="m"
            class="w-100"
            @click="$err.hide()"
          >
            OK
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
  export default {
    name: 'error-modal',
    data () {
      return {
        visible: false
      }
    }
  }
</script>
<style lang="scss" scoped>
  .error-wrapper {
    display: flex;
    align-items: center;
    svg {
      font-size: 3.5em;
    }
    span {
      padding-left: 10px;
      align-self: center;
    }
  }
</style>
